// * GET =====================================

export const USER_GET_DASHBOARD_BY_ID = (userId: string) =>
  `/user/${userId}/dashboard_by_id`;

export const UTILS_DATA_OBJECT_GET_LIST_USERS = '/utils_data_object/list_users';

export const USER_GET_ACCESSIBLE_FEED_TYPES = (userId: string) =>
  `/user/${userId}/accessible_feed_types`;

export const USER_GET_EXTERNAL_ACCOUNTS = (userId: string) =>
  `/user/${userId}/external_accounts`;

export const USER_GET_CLIPPING_FEEDS = '/user/clipping_feeds';

export const USER_GET_GET_RECENT_OBJECTS = '/user/get_recent_objects';

export const USER_GET_ACTIVATED_USER_COMPANIES =
  '/user/activated_user_companies';

// TODO: user.service.ts(line 1176) - research for that unused service
export const USER_GET = (userId: string) => `/user/${userId}`;

export const USER_GET_ALERTS = (userId: string) => `/user/${userId}/alerts`;

export const USER_GET_RECENT_SEARCHES = '/user/get_recent_searches';

export const USER_GET_CHECK_FOR_NEW_ALERTS = (userId: string) =>
  `/user/${userId}/check_for_new_alerts`;

export const USER_GET_NOTIFICATION_LIST = (userId: string) =>
  `/user/${userId}/notification_list`;

export const USER_GET_NOTIFICATION_LIST_COUNT = (userId: string) =>
  `/user/${userId}/notification_list_count`;

export const USER_GET_WORKSPACES = (userId: string) =>
  `/user/${userId}/workspaces`;

export const USER_GET_WORKSPACE_OBJECTS = `/user/workspace_objects`;

export const USER_GET_FEED_BY_ID = (userId: string) =>
  `/user/${userId}/feed_by_id`;

export const USER_GET_RECIPIENTS = (userId: string) =>
  `/user/${userId}/recipients`;

export const USER_GET_AVAILABLE_GROUPS = '/user/available_groups';

export const USER_GET_AVAILABLE_ROLES = '/user/available_roles';

export const USER_GET_AVAILABLE_COMPANIES = '/user/available_companies';

export const USER_GET_AVAILABLE_ACCOUNT_MANAGERS =
  '/user/available_account_managers';

export const USER_GET_BY_INVITE_TOKEN = '/user/by_invite_token';

export const USER_GET_BY_RESET_TOKEN = '/user/by_reset_token';

// * PATCH ===================================

// * POST ====================================
export const USER_POST_ADD_RECENT_OBJECT = '/user/add_recent_object';

export const USER_POST_ADD_RECENT_SEARCH = '/user/add_recent_search';

export const USER_POST_REMOVE_RECENT_SEARCH = '/user/remove_recent_search';

export const USER_POST_SAVE_CONTEXT_VALUE = '/user/save_context_value';

export const USER_POST_DARK_MODE = '/user/dark_mode';

/** The user's objects, by id - a batch read, POST because the ids are a body. */
export const USER_POST_OBJECTS = '/user/user_objects';

/** Search across the user's objects - POST because the criteria are a body. */
export const USER_POST_OBJECT_LIST = '/user/user_object_list';

export const USER_POST_ALERTS = `/user/alerts`;

export const USER_POST_DASHBOARDS = `/user/dashboards`;

export const USER_POST_FEEDS = `/user/feeds`;

export const USER_POST_DIMENSIONS = `/user/dimensions`;

export const USER_POST_SCHEDULES = `/user/schedules`;

export const USER_POST_AUTO_STORY_RUNS = `/user/auto_story_runs`;

export const USER_POST_DELETE_AUTO_STORY_RUN = `/user/delete_auto_story_run`;

export const USER_POST_ACTIVATE_ACCOUNT = `/user/activate_account`;

export const USER_POST_RESET_PASSWORD = `/user/reset_password`;

export const USER_POST_LANGUAGE = `/user/language`;

/** Update half of the former dual-use /user/manage_user; creation is USER_PUT_CREATE (SEN-5296). */
export const USER_POST_UPDATE = `/user/update`;

export const USER_POST_MENU_STATE = `/user/menu_state`;

export const USER_POST_SEND_FORGOTTEN_PASSWORD_EMAIL = `/user/send_forgotten_password_email`;

export const USER_POST_SEND_PLATFORM_INVITATION = `/user/send_platform_invitation`;

export const USER_POST_GET_PLATFORM_INVITATION_LINK = `/user/get_platform_invitation_link`;

export const USER_POST_SWITCH_COMPANY = `/user/switch_company`;

/** Move a user to another company: plan (a pending run), then execute or cancel it. */
export const USER_POST_MOVE_COMPANY_PLAN = `/user/move_company_plan`;

export const USER_POST_MOVE_COMPANY_EXECUTE = `/user/move_company_execute`;

export const USER_POST_MOVE_COMPANY_CANCEL = `/user/move_company_cancel`;

export const USER_POST_CHANGE_PASSWORD = (userId: string) =>
  `/user/${userId}/change_password`;

export const USER_POST_SELECT_ITEMS = (userId: string) =>
  `/user/${userId}/select_items`;

export const USER_POST_UNSELECT_ITEMS = (userId: string) =>
  `/user/${userId}/unselect_items`;

export const USER_POST_CLEAR_FEED_SELECTED_ITEMS = (userId: string) =>
  `/user/${userId}/clear_feed_selected_items`;

export const USER_POST_IMPORT_CSV = `/user/import_csv`;

export const USER_POST_LIST_COMPANY_OBJECTS = `/user/list_company_objects`;
// * DELETE ==================================
export const USER_DELETE_EXTERNAL_ACCOUNTS = (userId: string) =>
  `/user/${userId}/external_accounts`;

// * PUT =====================================

/** Create half of the former dual-use /user/manage_user (SEN-5296). */
export const USER_PUT_CREATE = `/user/create`;
